import api from '@/api/axios';

export type AvailableActionsResponse = {
  actions: string[];
};

export const fetchAvailableActions = async (
  supplierId: string,
): Promise<AvailableActionsResponse> => {
  const { data } = await api.get<AvailableActionsResponse>(`/suppliers/${supplierId}/actions`);

  return data;
};
